import React, { memo } from 'react'
import { useTheme } from 'styled-components'

import { bowtieTheme, topEventRadius, unfocusOpacity } from '../../../../../../../utils/constants'
import { Pulse, MiddlePulseContentContainer, TopEventCircle } from './styles'

interface Props {
    title: string
    onMiddlePulseClick: () => void
    focus: 'unfocus' | 'focus' | 'none'
}

export const MiddlePulse: React.FC<Props> = ({ title, onMiddlePulseClick, focus = 'none' }) => {
    const theme = useTheme()
    /* this function return color based on event Bowtie status */

    const handleMiddlePulseClick = (): void => {
        onMiddlePulseClick()
    }

    return (
        <g opacity={focus === 'unfocus' ? unfocusOpacity : 1}>
            <Pulse r={topEventRadius} fill={bowtieTheme.topEvent.pulseColor} />
            <TopEventCircle
                r={(topEventRadius * 2) / 2}
                fill={bowtieTheme.topEvent.topEventBackgroundColor}
                stroke={focus === 'focus' ? theme['blue-500'] : bowtieTheme.barrierColors.unknown}
                strokeWidth={focus === 'focus' ? 5 : 2}
                style={{ cursor: 'pointer' }}
                onClick={handleMiddlePulseClick}
            />
            <foreignObject
                width={(topEventRadius - 30) * 2}
                height={topEventRadius * 2 - 45}
                x={-((topEventRadius * 2) / 2) + 30}
                y={-((topEventRadius * 2) / 2) + 20}
                style={{ pointerEvents: 'none' }}
            >
                <MiddlePulseContentContainer>
                    <div className="topEventTitle">{title}</div>
                </MiddlePulseContentContainer>
            </foreignObject>
        </g>
    )
}

export default memo(MiddlePulse)
